import React from 'react';
import { Redirect } from 'react-router-dom';

import Icon from 'Core/Components/Icon';
import NotFound from 'Core/Status/NotFound';
import Headline from 'Core/Components/Headline';
import InfoBlock from 'RLX/Controllers/InfoBlock';
import PaneController from 'RLX/Controllers/PaneController';

import './PageEditorPane.scss';
import { PaneHeader, SectionTitle } from 'Dashboard/Panes/Common';
import PageContentEditor from 'Dashboard/Panes/PageEditor/PageContent';
import PageSettingsEditor from 'Dashboard/Panes/PageEditor/PageSettings';
import { deletePage } from 'RLX/State/Content/ContentActions';
import { scrollTo, getOffset } from 'Core/Utils/DomUtils';

class PageEditorPane extends PaneController {
  constructor (props) {
    super(props);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
  }

  componentWillReceiveProps ({ location }) {
    const { hash, pathname } = location;
    const position = hash && hash.length
      ? getOffset(`.PageContentEditor>section:nth-child(${hash.substring(1)})`)
      : 0;
    if (pathname !== this.props.location.pathname || hash.length > 1)
      scrollTo('main', position ? position.top : 0);
  }

  renderSingle (id) {
    const { location } = this.props;
    const pageIndex = this.getPageIndexById(id);
    const page = this.state.siteData.pages[pageIndex];
    const hasName = page && page.name && page.name.length;

    const pageTitle = hasName
      ? <span>{page.name.toUpperCase()} <small>PAGE</small></span>
      : `Untitled / ${id}`;

    return !page
      ? <NotFound homeUrl="/RLX/dash/pages" />
      : (
        <div className="Pane EditorPane PageEditorPane">
          <PaneHeader title={pageTitle}>
            <code className="meta">{page.external ? '' : '/'}{page.url}</code>

            <button className="slim negative" onClick={() => deletePage(page.id)}>
              <Icon fa="trash left"/> Delete Page
            </button>

            <a href={page.url} target="_blank">
              <button className="slim calm">
                <Icon fa="external-link-square left"/> Visit Page
              </button>
            </a>
          </PaneHeader>

          <SectionTitle pane="Page" text="Settings" icon="gear"/>

          <PageSettingsEditor pageIndex={pageIndex} page={page} />

          <SectionTitle pane="Page" text="Content" icon="cubes"/>

          {page.external
            ? (
              <InfoBlock>
                <b>External Link</b> pages are really just nav links to other sites or email addresses, and don't have editable content.
              </InfoBlock>
            ) : (
              <PageContentEditor page={page} />
            )
          }
        </div>
      );
  }

  renderIndex () {
    const pages = this.getPages();
    if (!pages) return null;
    const [ defaultPage ] = pages.length ? pages : [{}];
    const { id } = defaultPage;
    const defaultUrl = `/RLX/dash/pages/${id || ''}`;

    return window.location.pathname === defaultUrl
      ? <InfoBlock><h3>You don't seem to have any pages.</h3></InfoBlock>
      : <Redirect to={defaultUrl} />
  }
}

export default PageEditorPane;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/PageEditor/PageEditorPane.jsx